import { Typography } from "@material-ui/core"
import { TagCategory } from "api"
import SingleButtonSelection from "components/Reusable/Bit/SingleButtonSelection"
import Image from "next/image"
import { Ref, forwardRef } from "react"
import { isDesktop } from "react-device-detect"
import styled from "styled-components"
import colors from "theme/colors"
import { useCreateAiContext } from "./CreateAiContext"
const StyledTitle = styled(Typography).attrs({
  component: "h2",
  variant: "h2",
})`
  color: ${colors.black};
  white-space: nowrap;
  font-size: 26px;
  line-height: 0.6;
  font-family: Speedee, NarkisBlock, sans-serif;
  margin-bottom: 16px;
  text-align: right;
  ${(p) => p.theme.breakpoints.down("sm")} {
  }
`
const StyledLabel = styled.label<{
  $activeButton: boolean
  $noOneSelected: boolean
}>`
  cursor: pointer;
  width: 104px;
  height: 116px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border-radius: 8px;
  margin-bottom: 16px;
  &:not(:nth-child(3n)) {
    margin-left: 8px !important;
  }

  border: 1px solid
    ${(p) =>
      p.$noOneSelected
        ? p.theme.colors.disabled
        : p.$activeButton
        ? p.theme.colors.darkGreen
        : p.theme.colors.disabled};
  opacity: ${(p) => (p.$noOneSelected ? 1 : p.$activeButton ? 1 : 0.5)};
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 160px;
    height: 178px;
  }
`
const StyledSingleButtonSelection = styled(SingleButtonSelection)`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 32px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    padding: 0 8px;
  }
  ${(p) => p.theme.breakpoints.up("md")} {
    gap: 24px;
    margin-bottom: 60px;

    .MuiButtonBase-root {
      width: 160px;
      height: 178px;
    }
  }
`

const StyledExplanation = styled(Typography).attrs({
  variant: "body1",
})`
  font-size: 24px;
  font-weight: 100;
  color: #000;
  line-height: 0.92;
  text-align: right;
  margin-top: 4px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    font-size: 18px;
  }
`
const StyledImage = styled.img`
  position: absolute;
  right: 8px;
  top: 8px;
  width: 20px;
  height: 20px;
`

const StyledError = styled(Typography).attrs({ variant: "body1" })`
  color: #d70202;
  font-size: 18px;
  line-height: 1;
  position: absolute;
  bottom: -16px;
  margin: 0px;
`

const StyledWrapper = styled.div`
  position: relative;
`

const BackgroundsAi = forwardRef(
  (
    {
      backgrounds,
      checkValiation,
    }: {
      backgrounds: TagCategory[]
      checkValiation: boolean
    },
    bgRef: Ref<HTMLInputElement>
  ) => {
    const { setBackgroundsData, backgroundsData } = useCreateAiContext()
    return (
      <StyledWrapper>
        <StyledTitle>{backgrounds[0]?.name}</StyledTitle>
        <StyledSingleButtonSelection
          id="amount"
          ref={bgRef}
          items={backgrounds[0]?.tags?.map((background) => ({
            value: background.id,
            name: background.name,
          }))}
          onSelect={(code) => {
            setBackgroundsData(
              backgrounds[0]?.tags.find((b) => b.id === code).id
            )
          }}
          gap={15}
          itemsPerRow={isDesktop ? 5 : "auto"}
          selectedValue={backgroundsData}
          allowEmpty
          customButton={(radioId, isSelected, item, index) => {
            return (
              <>
                <StyledLabel
                  htmlFor={radioId}
                  $noOneSelected={!backgroundsData}
                  $activeButton={item.value === backgroundsData}
                >
                  <Image
                    src={backgrounds[0]?.tags[index]?.image.imageUrl}
                    alt={backgrounds[0]?.tags[index]?.image.alt}
                    width={isDesktop ? 144 : 96}
                    height={isDesktop ? 128 : 80}
                  />

                  <StyledImage
                    src={
                      isSelected
                        ? "/img/icons/RadiobuttonChecked.png"
                        : "/img/icons/Radiobutton.png"
                    }
                    alt="check-icon"
                  />

                  <StyledExplanation>
                    {backgrounds[0]?.tags[index]?.name}
                  </StyledExplanation>
                </StyledLabel>
              </>
            )
          }}
        />
        {!backgroundsData && checkValiation && (
          <StyledError>יש לבחור צבע רקע</StyledError>
        )}
      </StyledWrapper>
    )
  }
)
BackgroundsAi.displayName = "BackgroundsAi"
export default BackgroundsAi
